/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

const LISTAR_BANDEIRA = `/identity/informacoes-usuario/v1/bandeiras`;

const fetchData = async () => {
  const response = await instance.get(LISTAR_BANDEIRA);
  return response?.data?.data;
};

export function useReceberBandeira() {
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["listar_bandeira"],
    refetchOnWindowFocus: false,
  });
  return query;
}
